export default __webpack_public_path__ + "rex-home-full-logo.f4dae607.png";